import { track } from "@vercel/analytics";

/**
 * Product events, sent as Vercel Web Analytics custom events (Pro plan).
 * Read them under Vercel → web-app → Analytics → Events. No personal data:
 * only the event name and where it happened.
 */
export type AnalyticsEvent =
  | "homepage_view"
  | "hero_cta_click"
  | "map_open"
  | "field_guide_open"
  // Funnel (WN-245). `membership_checkout_started` is sent by the API
  // (api/stripe/create-checkout-session.js) so app checkouts count too.
  | "signup_started"
  | "signup_completed"
  | "email_subscribed"
  | "membership_purchased"
  | "env_sample_limit_hit"
  | "spot_tapped"
  | "experience_checkout_started";

type EventProps = Record<string, string | number | boolean | null | undefined>;

/**
 * The analytics script loads a few seconds after the page (DeferredAnalytics),
 * and `track` drops events sent before it exists. Vercel's own queue holds
 * them until it loads, the same one its `inject()` sets up.
 */
function ensureQueue(): void {
  if (typeof window === "undefined" || window.va) return;
  window.va = (event, properties) => {
    if (!window.vaq) window.vaq = [];
    window.vaq.push([event, properties]);
  };
}

export function trackEvent(name: AnalyticsEvent, props?: EventProps): void {
  try {
    ensureQueue();
    track(name, props);
  } catch {
    // Analytics must never break the page.
  }
}
